import {useEffect, useState} from "react";
import axios from "axios";
import {shuffle} from "utils/array";

const NewItems = () => {
  const NEW_ITEMS_DISPLAY_NUM = 5;

  const [items, setItems] = useState([]);
  useEffect(() => {
    axios
      .get('files/cobrand/new_items.json')
      .then(response => {
        const items = shuffle(response.data);
        setItems(items.slice(0, NEW_ITEMS_DISPLAY_NUM));
      });
  }, []);

  return (
    <>
      {items.length > 0 &&
        <section className="tw-about__list clearfix">
          <h3 className="title__product-list">新着商品 Newly Listed</h3>
          <ul className="product-list">
            {items.map((item, i) =>
              <li className="item" key={i}>
                <a href={item.BuyeeUrl} target="_blank">
                  <div className="item__img">
                    <img className="product-img" src={item.Image}/>
                  </div>
                  <div className="item__name">{item.TitleJp}</div>
                  <div className="item__remaining-time">
                    <p className="txt">剩餘時間</p>
                    <p className="left-time">{item.RemainingTime}</p>
                  </div>
                  <div className="item__price">{item.CurrentPriceJp}日元</div>
                  <div className="item__price-fx">{item.CurrentPrice}台幣</div>
                </a>
              </li>
            )}
          </ul>
        </section>
      }
    </>
  );
};

export default NewItems;
